export default "__VITE_ASSET__fbc61dc5__"